<template>
  <div class="find-vacancy-q-page__footer">
    <button
      v-if="showBack"
      :disabled="!canBack"
      class="find-vacancy-q-page__footer-btn  base-btn  base-btn--outline-blue"
      @click.prevent="$emit('back')"
    >
      {{ $tFindVacancy('Back') }}
    </button>

    <button
      v-if="showSave"
      :disabled="!canSave"
      class="find-vacancy-q-page__footer-btn  base-btn  base-btn--green _save"
      @click.prevent="$emit('save')"
    >
      {{ saveBtnText }}
    </button>
    <button
      v-else
      :disabled="!canNext"
      class="find-vacancy-q-page__footer-btn  base-btn  base-btn--green"
      @click.prevent="$emit('next')"
    >
      {{ $tFindVacancy('Next') }}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'FindVacancyQPageFooter',
    props: {
      canNext: Boolean,
      canBack: Boolean,
      canSave: Boolean,
      showBack: {
        type: Boolean,
        default: true,
      },
      showSave: Boolean,
      forAgent: Boolean,
      saveButtonText: String,
    },
    computed: {
      saveBtnText() {
        return this.saveButtonText || this.$tFindVacancy(this.forAgent ? 'Find vacancy button for agent' : 'Find vacancy button');
      },
    },
  }
</script>
